const React = require('react');

import LandingV2 from './components/landingV2.jsx.js';

export class HomePage extends React.Component {
   render() {
      return (
         <LandingV2
            lastFilterFunction={this.props.lastFilterFunction}
            headlines={this.props.headlines}
            amaCards={this.props.amaCards}
         />
      );
   }
};
